module.exports = __webpack_public_path__ + "static/media/piyushi.b054e7e6.jpg";